import { render } from "./PunchIn.vue?vue&type=template&id=473094da"
import script from "./PunchIn.vue?vue&type=script&lang=js"
export * from "./PunchIn.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__